import { FileText, Image as ImageIcon, X } from 'lucide-react';
import { SafeImage } from '@/shared/ui';
import type { AnexoMia } from './assistenteService';
import styles from './AssistenteWidget.module.css';

type Props = {
  anexos: AnexoMia[];
  /** No compositor: tira o anexo antes de enviar. */
  onRemover?: (idArquivo: number) => void;
};

/** Fotos e PDFs da fala (no balao da pessoa ou no compositor, antes de enviar). */
export function AnexosMia({ anexos, onRemover }: Props) {
  if (anexos.length === 0) return null;
  return (
    <ul className={styles.anexos} aria-label="Anexos">
      {anexos.map((anexo) => (
        <li key={anexo.idArquivo} className={styles.anexo}>
          {anexo.urlThumb ? (
            <SafeImage src={anexo.urlThumb} alt="" variant="thumb" className={styles.anexoMiniatura} />
          ) : anexo.tipo === 'pdf' ? (
            <FileText size={16} aria-hidden />
          ) : (
            <ImageIcon size={16} aria-hidden />
          )}
          <span className={styles.anexoNome}>{anexo.nome}</span>
          {onRemover ? (
            <button
              type="button"
              className={styles.anexoRemover}
              aria-label={`Tirar ${anexo.nome}`}
              onClick={() => onRemover(anexo.idArquivo)}
            >
              <X size={14} />
            </button>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
